import { createStore, applyMiddleware, compose } from "redux"
import thunkMiddleware from "redux-thunk"
import promiseMiddleware from "redux-promise-middleware"
import reducer from "./reducer.js"

//启用redux调试工具
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

//启用redux-thunk
const storeEnhancer = applyMiddleware(thunkMiddleware, promiseMiddleware)

const store = createStore(reducer, composeEnhancers(storeEnhancer))

export default store
